// routes.js

import Booking from "../pages/booking";
import HomePage from "../pages/home-page";
import LoginPage from "../pages/login";
import PropertyDetail from "../pages/property-details";
import PropertyListing from "../pages/property-listing";
import ConfirmBooking from "../pages/booking-confirmation";
import MyAccount from "../pages/my-account";
import MyProfile from "../components/my-account/myprofile";
import WishList from "../components/my-account/wishlist";
import AssignedProperty from "../components/my-account/assigned-property";
import BillsPayments from "../components/my-account/bills-payments";
import SupportRequest from "../components/my-account/support-request";
import Feedback from "../components/my-account/feedback";
import AboutUs from "../pages/about-us";
import FaqPage from "../pages/faq";
import PrivacyPolicy from "../pages/privacy-policy";
import TermsConditions from "../pages/terms-conditions";
import CancellationPolicy from "../pages/cancellation-policy";
import BlogPage from "../pages/blogs";
import BlogPost from "../pages/blog-post";
import ListYourProperty from "../pages/list-your-property";
import ContactUs from "../pages/contact-us";
import RegistrationPage from "../pages/registration";
import Checkout from "../pages/checkout";
import BookingFailure from "../pages/booking-failure";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import PropertyListingNavigate from "../pages/property-listing-navigate";
import PageNotFound from "../pages/page-not-found";
import OwnerAccount from "../pages/owner-account";
import OwnerProfile from "../components/owner-account/ownerprofile";
import OwnerLogin from "../pages/owner-login";
import OwnerAggerment from "../components/owner-account/owner-profile-agreement";
import OwnerBankDetails from "../components/owner-account/owner-bank-details";
import OwnerProfileDocs from "../components/owner-account/owner-profile-docs";
import OwnerProperty from "../components/owner-account/owner-property";
import OwnerChangePassword from "../components/owner-account/owner-change-password";
import OwnerAuditTable from "../components/owner-account/owner-property-audit";
import MyExpense from "../components/owner-account/owner-my-expense";
import MyRnetExpense from "../components/owner-account/expense-rent-report";
import Properties from "../components/owner-account/properties";
import BuyPage from "../pages/buy";
import BuyPropertyList from "../pages/buy-property-list";
import BuyPropertyDetail from "../pages/buy-property-detail";
import Sell from "../pages/sell";
import Whywerentt from "../pages/why-werentt";
import MortgageCalculator from "../pages/Mortgage";
import BuyVsRentCalculator from "../pages/BuyvsRent";
import AboutUsMobile from "../pages/about-us-mobile";
import MobileBooking from "../pages/booking-mobile";
import CheckoutMobile from "../pages/checkOutMobile";
import ConfirmBookingMobile from "../pages/booking-confirmation-mobile";
import BookingFailureMobile from "../pages/booking-failure-mobile";
import RentSiteMap from "../pages/rentSiteMap";
import HomeBuyerSurvey from "../pages/home-buyer-survey";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/sell",
    element: <Sell />,
  },
  {
    path: "property/:slug",
    element: <PropertyDetail />,
  },
  {
    path: "properties",
    element: <PropertyListing />,
  },
  {
    path: "login",
    element: <PublicRoute element={<LoginPage />} />,
  },
  {
    path: "ownerlogin",
    element: <PublicRoute element={<OwnerLogin />} />,
  },

  {
    path: "registration",
    element: <PublicRoute element={<RegistrationPage />} />,
  },
  {
    path: "/booking",
    element: <PrivateRoute element={<Booking />} />,
  },
  {
    path: "/booking-mobile",
    element: <PrivateRoute element={<MobileBooking />} />,
  },
  {
    path: "/checkout",
    element: <PrivateRoute element={<Checkout />} />,
  },
  {
    path: "/checkout-mobile",
    element: <PrivateRoute element={<CheckoutMobile />} />,
  },
  {
    path: "/booking-confirmation",
    element: <PrivateRoute element={<ConfirmBooking />} />,
  },
  {
    path: "/booking-confirmation-mobile",
    element: <PrivateRoute element={<ConfirmBookingMobile />} />,
  },
  {
    path: "/booking-failure",
    element: <PrivateRoute element={<BookingFailure />} />,
  },
  {
    path: "/booking-failure-mobile",
    element: <PrivateRoute element={<BookingFailureMobile />} />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/why-werentt",
    element: <Whywerentt />,
  },
  {
    path: "/mortgage-calculator",
    element: <MortgageCalculator />,
  },
  {
    path: "/buy-vs-rent",
    element: <BuyVsRentCalculator />,
  },
  {
    path: "/buy",
    element: <BuyPage />,
  },
  {
    path: "/buy/list",
    element: <BuyPropertyList />,
  },
  {
    path: "/buy/detail/:slug",
    element: <BuyPropertyDetail />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/survey",
    element: <HomeBuyerSurvey />,
  },
  {
    path: "/blogs",
    element: <BlogPage />,
  },
  {
    path: "/blogs/:slug",
    element: <BlogPost />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/list-your-property",
    element: <ListYourProperty />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/cancellation-policy",
    element: <CancellationPolicy />,
  },
  //here i changed the path /:location becuase its no longer need we are passing the location inside the slug olny.
  {
    path: "rent/:slug",
    element: <PropertyListingNavigate />,
  },

  //abouts us page only for mobile
  {
    path: "/about-werentt",
    element: <AboutUsMobile />,
  },
  {
    path: "/rent-sitemap",
    element: <RentSiteMap />,
  },
  {
    path: "/my-account",
    element: <PrivateRoute element={<MyAccount />} />,
    children: [
      { path: "profile", element: <PrivateRoute element={<MyProfile />} /> },
      { path: "wishlist", element: <PrivateRoute element={<WishList />} /> },
      {
        path: "assigned-property",
        element: <PrivateRoute element={<AssignedProperty />} />,
      },
      {
        path: "bills-payments",
        element: <PrivateRoute element={<BillsPayments />} />,
      },
      {
        path: "support-request",
        element: <PrivateRoute element={<SupportRequest />} />,
      },
      { path: "feedback", element: <PrivateRoute element={<Feedback />} /> },
    ],
  },
  {
    path: "/owner-account",
    element: <PrivateRoute element={<OwnerAccount />} />,
    children: [
      {
        path: "ownerprofile",
        element: <PrivateRoute element={<OwnerProfile />} />,
      },
      {
        path: "owner-change-password",
        element: <PrivateRoute element={<OwnerChangePassword />} />,
      },
      {
        path: "owner-profile-agreement/:propertyGuid",
        element: <PrivateRoute element={<OwnerAggerment />} />,
      },
      {
        path: "owner-bank-details",
        element: <PrivateRoute element={<OwnerBankDetails />} />,
      },
      {
        path: "owner-profile-docs",
        element: <PrivateRoute element={<OwnerProfileDocs />} />,
      },
      {
        path: "properties",
        element: <PrivateRoute element={<Properties />} />,
      },
      {
        path: "owner-property/:propertyGuid",
        element: <PrivateRoute element={<OwnerProperty />} />,
      },
      {
        path: "photos",
        element: <PrivateRoute element={<OwnerAuditTable />} />,
      },
      {
        path: "my-expenses",
        element: <PrivateRoute element={<MyExpense />} />,
      },
      {
        path: "revenue",
        element: <PrivateRoute element={<MyRnetExpense />} />,
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];

export default routes;
